import SettingTypes from '@/utils/setting-types'

export default {
  name: 'screen-blocks',
  label: {
    title: '多宫格',
    icon: require('@/assets/icon-component-label_ScreenBlocks.svg'),
    limit: -1
  },
  sort: 1005,
  data: {
    title: '多宫格',
    style: '3',
    blocks: []
  },
  settings: {
    title: {
      type: SettingTypes.input,
      label: '多宫格标题'
    },
    style: {
      type: SettingTypes.radio_button,
      label: '宫格样式',
      options: [
        { label: '图标三列', value: '3' },
        { label: '大图四列', value: '4' }
      ]
    },
    blocks: {
      type: SettingTypes.custom,
      component_name: 'ScreenBlocksSettings'
    }
  }
}
